import { DesignerFeature, DesignerFeatures } from '@/types';
import { isAdminMode, isEmbroideryMode, isTemplateAdminMode, isUserAreaMode } from '@/utils/params';

const FEATURES: { [prop: string]: boolean } = {
  platformCheckout: true,
  showProductTypeGallery: true,
  showDesignGallery: true,
  showDesignUpload: true,
  showAddText: true,
  showAddSpecialText: true,
  showSaveAndShare: true,
  showDesignPrices: true,
  showMarketplaceDesigns: true,
  showUserDrafts: true,
};

export const getFeatures = () => ({ ...FEATURES });

export const getConfiguredFeatures = (paramFeatures: DesignerFeatures = {}) => {
  let features: DesignerFeatures = getFeatures();

  if (isUserAreaMode()) {
    features.showSaveAndShare = false;
    features.showAddSpecialText = false;
    features.showDesignUpload = false;
  }

  if (isAdminMode()) {
    features.showSaveAndShare = false;
  }

  if (isTemplateAdminMode()) {
    features.showAddPlaceholderText = true;
    features.showDesignUpload = false;
  }

  if (isEmbroideryMode()) {
    features.showAddSpecialText = false;
    features.showDesignGallery = false;
    features.showDesignUpload = true;
    features.showUserDrafts = false;
    features.showDesignGallery = true;
  }

  const search = window.location.search.replace(/^\?/, '').split('&');
  search.forEach((queryParam) => {
    const [key, value] = queryParam.split('=');
    const feature = key as DesignerFeature;
    if (FEATURES[feature] !== undefined) {
      if (value === 'true') {
        features[feature] = true;
      } else if (value === 'false') {
        features[feature] = false;
      }
    }
  });

  features = { ...features, ...paramFeatures };

  return features;
};
